import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=53f0b824&scoped=true"
import script from "./StoreDetail.vue?vue&type=script&lang=js"
export * from "./StoreDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0b824",
  null
  
)

export default component.exports